import $ from "jquery";
import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import * as Common from "../CommonControlls/CommonJs";
import DropDown from "../CommonControlls/DropdownRendrer";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import BarsGraph from "../Graphs/BarsGraph";
import LineChart from "../Graphs/LineChart";
import PieCharts from "../Graphs/PieCharts";
import { SyncConfig } from "../OfflineDb/ConfigDataSync";
import { SelectPageLastSearch } from "../OfflineDb/IndexDbTranscSP";

const mapStateToProps = (store) => {
	return store;
};

const mapDispatchToProps = (dispatch) => {
	return {
		ShowAlert: (Settings) => {
			dispatch({ type: "UpdateAlert", payload: Settings });
		},
		ShowLoader: (Isloading) => {
			dispatch({ type: "UpdateLoader", payload: Isloading });
		},
	};
};

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showFilters: false,
			showButton: {
				sampleReceived: false,
				sampleDelivered: false,
				samplesAddedByXpert: false,
				totalAFB: false,
				totalMTB: false,
				totalRR: false,
				avgCost: false,
				totalRide: false,
				hcf: false,
			},
			subRecepientBarsChartData: [
				{
					label: "",
					value: 0,
				},
			],
			permissions: [],
			activeDistricts: 0,
			inActiveDistricts: 0,
			totalRRCases: 0,
			totalMtbNotdetected: 0,
			totalMtbCaseError: 0,
			totalMtbCaseInvalid: 0,
			totalAssignmentsCreated: 0,

			ProvinceLoader: false,
			Provincelist: [],
			ProvinceId: [],

			category: "",

			DistrictLoader: false,
			Districtlist: [],
			FilteredDistrictlist: [],
			DistrictId: [],

			TehsilLoader: false,
			Tehsillist: [],
			FilteredTehsillist: [],
			TehsilId: [],

			startDate: new Date(),
			endDate: new Date(),

			totalSampleCollected: 0,
			sampleSubmittedfromBHU: 0,
			sampleSubmittedfromRHC: 0,
			sampleSubmittedfromXpert: 0,
			totalSampleDelivered: 0,
			totalAFBPositiveCases: 0,
			totalAFBNegativeCases: 0,
			sampleSubmittedfromXpert: 0,
			totalMTBCases: 0,
			rideAVGCost: 0,
			ActiveXpert: 0,
			InactiveXpert: 0,
			activeXpert: 0,

			publicHCF: 0,
			privateHCF: 0,
			sampleAVGCost: 0,

			LineChartData: [
				[
					"Days",
					"Sample received",
					"RR cases",
					"MTB cases",
					"AFB Positive cases",
					"AFB Negative cases",
				],
				["", 0, 0, 0, 0, 0],
				["", 0, 0, 0, 0, 0],
				["", 0, 0, 0, 0, 0],
				["", 0, 0, 0, 0, 0],
				["", 0, 0, 0, 0, 0],
				["", 0, 0, 0, 0, 0],
				["", 0, 0, 0, 0, 0],
			],

			PieChartData: [["District", "Count"]],

			BarsChartData: [
				{
					label: "",
					value: "0",
				},
				{
					label: "",
					value: "0",
				},
				{
					label: "",
					value: "0",
				},
				{
					label: "",
					value: "0",
				},
				{
					label: "",
					value: "0",
				},
				{
					label: "",
					value: "0",
				},
				{
					label: "",
					value: "0",
				},
			],

			ActiveHCF: 0,
			InactiveHCF: 0,

			XpertSiteLoader: false,
			XpertSitelist: [],
			XpertSiteId: [],

			HCFLoader: false,
			HCFList: [],
			BHUList: [],
			RHCList: [],
			BHUId: [],
			RHCId: [],

			isMicroscope: false,
			TbRegisteredPatients: 0,
			FunctionRiders: {},
			filteredBHUList: [],
			filteredRHCList: [],
			filteredXpertSiteList: [],

			AgeBracket: [
				{ id: "0", name: "All" },
				{ id: "5", name: "5" },
				{ id: "10", name: "10" },
				{ id: "15", name: "15" },
				{ id: "20", name: "20" },
				{ id: "25", name: "25" },
				{ id: "30", name: "30" },
				{ id: "35", name: "35" },
				{ id: "40", name: "40" },
				{ id: "45", name: "45" },
				{ id: "50", name: "50" },
				{ id: "55", name: "55" },
				{ id: "60", name: "60" },
				{ id: "65", name: "65" },
				{ id: "70", name: "70" },
				{ id: "75", name: "75" },
				{ id: "80", name: "80" },
				{ id: "85", name: "85" },
				{ id: "90", name: "90" },
				{ id: "95", name: "95" },
				{ id: "100", name: "100" },
			],
			startAge: null,
			endAge: null,
			SrList: [],
			FilteredSrs: [],
			SrId: [],

			isSaveSearch: false,
			// isSearchChanged:false,

			SR_bhUs: 0,
			SR_gPs: 0,
			SR_ppmLabs: 0,
			SR_rhCs: 0,
			SR_totalSamples: 0,
			SR_loading: false,

			//SATR_bhUs: 0,
			//SATR_gPs: 0,
			//SATR_ppmLabs: 0,
			//SATR_rhCs: 0,
			SATR_totalSamples: 0,
			SATR_completedRides: 0,
			SATR_totalIncentivesForCompletedRides: 0,
			SATR_loading: false,

			TS_bhUs: 0,
			TS_gPs: 0,
			TS_ppmLabs: 0,
			TS_rhCs: 0,
			TS_totalSamples: 0,
			TS_loading: false,

			TATS_bhUs: 0,
			TATS_gPs: 0,
			TATS_ppmLabs: 0,
			TATS_rhCs: 0,
			TATS_totalSamples: 0,
			TATS_loading: false,

			afbPositiveSamples: 0,
			afbTestedSamples: 0,
			samplesTransportedForAFBTest: 0,
			afbAverageCost: 0,
			afbloading: false,

			gxTestedSamples: 0,
			mtbDetectedSamples: 0,
			samplesTransportedForGXTest: 0,
			mtbAverageCost: 0,
			mtbloading: false,

			rr_gxTestedSamples: 0,
			rr_mtbDetectedSamples: 0,
			rr_DetectedSamples: 0,
			rr_AverageCost: 0,
			rr_loading: false,

			activePrivateGXSites: 0,
			activePublicGXSites: 0,
			samplesTestedPrivateGX: 0,
			samplesTestedPublicGX: 0,
			totalPrivateGXSites: 0,
			totalPublicGXSites: 0,
			GXSitesloading: false,

			activeDistricts: 0,
			activeRidersCVR: 0,
			activeRidersProjectStaff: 0,
			activeRidersPublicServant: 0,
			totalDistricts: 0,
			totalRidersCVR: 0,
			totalRidersProjectStaff: 0,
			totalRidersPublicServant: 0,
			RD_loading: false,

			activeBHU: 0,
			activeGP: 0,
			activePPMLabs: 0,
			activeRHC: 0,
			totalBHU: 0,
			totalGP: 0,
			totalPPMlabs: 0,
			totalRHC: 0,
			activeLoading: false,

			turnAroundTimeAFBTesting: 0,
			turnAroundTimeGXTesting: 0,
			turnAroundTimeTransportation: 0,
			turnAroundTimeloading: false,

			bhus: 0,
			gps: 0,
			ppmlabs: 0,
			rhcs: 0,
			bhuloading: false,
		};
		this.componentRef = React.createRef();
	}

	componentWillMount() {
		if (this.props.UserAuthentication.AuthToken === "") {
			this.props.history.push("/Login");
		}
	}

	componentDidMount() {
		Common.AddClassToMenueLink("MenuLink_Dashboard");
		var date = Common.GetPastSubtractedDate(new Date(), 7);
		this.setState(
			{
				startDate: date,
			},
			() => {
				this.GetPageConfigData(() => {
					SelectPageLastSearch(
						"Dashboard",
						(resp) => {
							if (resp.status) {
								var ProvinceId = [];
								var DistrictId = [];
								var TehsilId = [];
								var BHUId = [];
								var RHCId = [];
								var XpertSiteId = [];

								var ProvinceIdList =
									resp.data.povinceIdString === ""
										? []
										: resp.data.povinceIdString
											.slice(1, -1)
											.split(",")
											.map(Number);
								if (ProvinceIdList.length > 0) {
									for (var i in this.state.Provincelist) {
										if (
											ProvinceIdList.indexOf(this.state.Provincelist[i].id) > -1
										) {
											ProvinceId.push(this.state.Provincelist[i]);
										}
									}
								}

								var DistrictIdList =
									resp.data.districtIdString === ""
										? []
										: resp.data.districtIdString
											.slice(1, -1)
											.split(",")
											.map(Number);
								if (DistrictIdList.length > 0) {
									for (var i in this.state.Districtlist) {
										if (
											DistrictIdList.indexOf(this.state.Districtlist[i].id) > -1
										) {
											DistrictId.push(this.state.Districtlist[i]);
										}
									}
								}

								var TehsilIdList =
									resp.data.tehsilIdString === ""
										? []
										: resp.data.tehsilIdString
											.slice(1, -1)
											.split(",")
											.map(Number);
								if (TehsilIdList.length > 0) {
									for (var i in this.state.Tehsillist) {
										if (
											TehsilIdList.indexOf(this.state.Tehsillist[i].id) > -1
										) {
											TehsilId.push(this.state.Tehsillist[i]);
										}
									}
								}

								var BHUIdList =
									resp.data.bhuIdString === ""
										? []
										: resp.data.bhuIdString.slice(1, -1).split(",").map(Number);
								if (BHUIdList.length > 0) {
									for (var i in this.state.BHUList) {
										if (BHUIdList.indexOf(this.state.BHUList[i].id) > -1) {
											BHUId.push(this.state.BHUList[i]);
										}
									}
								}

								var RHCIdList =
									resp.data.rhcIdString === ""
										? []
										: resp.data.rhcIdString.slice(1, -1).split(",").map(Number);
								if (RHCIdList.length > 0) {
									for (var i in this.state.RHCList) {
										if (RHCIdList.indexOf(this.state.RHCList[i].id) > -1) {
											RHCId.push(this.state.RHCList[i]);
										}
									}
								}

								var XpertSiteIdList =
									resp.data.xpertIdString === ""
										? []
										: resp.data.xpertIdString
											.slice(1, -1)
											.split(",")
											.map(Number);
								if (XpertSiteIdList.length > 0) {
									for (var i in this.state.XpertSitelist) {
										if (
											XpertSiteIdList.indexOf(this.state.XpertSitelist[i].id) >
											-1
										) {
											XpertSiteId.push(this.state.XpertSitelist[i]);
										}
									}
								}

								this.setState(
									{
										startDate: new Date(
											Common.ConvertToLocalDateTime(resp.data.fromDate)
										),
										endDate: new Date(
											Common.ConvertToLocalDateTime(resp.data.toDate)
										),
										ProvinceId: ProvinceId,
										DistrictId: DistrictId,
										TehsilId: TehsilId,
										BHUId: BHUId,
										RHCId: RHCId,
										XpertSiteId: XpertSiteId,
									},
									() => {
										this.GetDashboardStats();
									}
								);
							} else {
								this.GetDashboardStats();
							}
						},
						() => { }
					);
				});
			}
		);

		this.SelectSubReciepents();
		this.SelectFunctionNonFunctionRiders();
		this.SelectTBRegisteredPatients();
		this.SelectActiveInactiveHCF();
		this.SelectActiveInactiveXpertSite();

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_RolesPermissions,
			{
				pageSize: 15,
				pageNumber: 1,
			},
			(resp) => {
				const modifiedPermissions = resp.data
					.filter(
						(p) => p.permissioN_GROUP === "Dashboard" && p.permissioN_ALLOWED
					)
					.map((d) => d.permissioN_NAME);
				this.setState({ permissions: modifiedPermissions });
			}
		);
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.BaseUrlAPI + "/api/HCF/HCFCategoryCount",
			{},
			(resp) => {
				this.setState({
					privateHCF: resp.data[0].privateHCF,
					publicHCF: resp.data[0].publicHCF,
				});
			}
		);
		this.props.ShowLoader({ Isloading: false });
	}

	HandleDateChange = (Field, date) => {
		this.setState(
			{
				[Field]: date === "" || date == null ? new Date() : date,
				// isSaveSearch: this.state.isSearchChanged ? true : false
			},
			() => {
				if (
					Field === "startDate" &&
					this.state.startDate > this.state.endDate
				) {
					this.setState({ endDate: this.state.startDate });
				}
			}
		);
	};
	HandleAutoSuggestValChange = (fieldId, value) => {
		this.setState(
			{
				[fieldId]: value,
				// isSaveSearch: this.state.isSearchChanged ? true : false
			},
			() => {
				if (fieldId === "ProvinceId") {
					this.FilterDistricts(value);
				}
				if (fieldId === "SrId") {
					var selectedSrs = this.state.SrId;
					const tempDistricts = this.state.Districtlist;
					var filteredSrsId = Common.ConvertToCommaSplitArray(
						selectedSrs,
						"id"
					);
					var filteredSelectedDistricts = tempDistricts.filter(function (obj) {
						return filteredSrsId.indexOf(obj.subrecipientid) > -1;
					});
					this.setState({
						FilteredDistrictlist: filteredSelectedDistricts,
					});
				}
				if (fieldId === "DistrictId") {
					this.FilterTehsils(value);
				}
				if (fieldId === "TehsilId") {
					this.FilterDependant();
				}
			}
		);
	};
	FilterDistricts = (value) => {
		// filter ditrict list
		var TempArr = this.state.Districtlist;
		var selectedProvince = Common.ConvertToCommaSplitArray(value, "id");
		var filteredDistrictList = TempArr.filter(function (obj) {
			return selectedProvince.indexOf(obj.provinceId) > -1;
		});

		const tempSrs = this.state.SrList;
		const filteredSrs = tempSrs.filter(
			(item) => selectedProvince.indexOf(item.provinceid) > -1
		);

		// filter district selected values
		var selectedDistricts = this.state.DistrictId;
		var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(
			filteredDistrictList,
			"id"
		);
		var filteredSelectedDistricts = selectedDistricts.filter(function (obj) {
			return filteredDistrictIdArr.indexOf(obj.id) > -1;
		});

		this.setState(
			{
				FilteredDistrictlist: filteredDistrictList,
				DistrictId: filteredSelectedDistricts,
				FilteredSrs: filteredSrs,
			},
			() => {
				this.FilterDependant();
			}
		);
	};
	FilterTehsils = (value) => {
		// filter Tehsil list
		var TempArr = this.state.Tehsillist;
		var selectedVale = Common.ConvertToCommaSplitArray(value, "id");
		var filteredTehsilList = TempArr.filter(function (obj) {
			return selectedVale.indexOf(obj.districtId) > -1;
		});

		// filter Tehsil selected values
		var selectedTehsils = this.state.TehsilId;
		var filteredTehsilIdArr = Common.ConvertToCommaSplitArray(
			filteredTehsilList,
			"id"
		);
		var filteredSelectedTehsils = selectedTehsils.filter(function (obj) {
			return filteredTehsilIdArr.indexOf(obj.id) > -1;
		});

		this.setState(
			{
				FilteredTehsillist: filteredTehsilList,
				TehsilId: filteredSelectedTehsils,
			},
			() => {
				this.FilterDependant();
			}
		);
	};
	FilterDependant = () => {
		var selectedVale = Common.ConvertToCommaSplitArray(
			this.state.TehsilId,
			"id"
		);

		// Filter BHU
		var TempBHUList = this.state.BHUList;
		var filteredBHUList = TempBHUList.filter(function (obj) {
			return selectedVale.indexOf(obj.tehsilId) > -1;
		});
		var selectedBHU = this.state.BHUId;
		var filteredBHUIdArr = Common.ConvertToCommaSplitArray(
			filteredBHUList,
			"id"
		);
		var filteredSelectedBHU = selectedBHU.filter(function (obj) {
			return filteredBHUIdArr.indexOf(obj.id) > -1;
		});

		// Filter RHC
		var TempRHCList = this.state.RHCList;
		var filteredRHCList = TempRHCList.filter(function (obj) {
			return selectedVale.indexOf(obj.tehsilId) > -1;
		});
		var selectedRHC = this.state.RHCId;
		var filteredRHCIdArr = Common.ConvertToCommaSplitArray(
			filteredRHCList,
			"id"
		);
		var filteredSelectedRHC = selectedRHC.filter(function (obj) {
			return filteredRHCIdArr.indexOf(obj.id) > -1;
		});

		// Filter xpert site
		var TempXpertSitelist = this.state.XpertSitelist;
		var filteredXpertSiteList = TempXpertSitelist.filter(function (obj) {
			return selectedVale.indexOf(obj.tehsilId) > -1;
		});
		var selectedXpertsite = this.state.XpertSiteId;
		var filteredXpertSiteIdArr = Common.ConvertToCommaSplitArray(
			filteredXpertSiteList,
			"id"
		);
		var filteredSelectedXpertSite = selectedXpertsite.filter(function (obj) {
			return filteredXpertSiteIdArr.indexOf(obj.id) > -1;
		});

		this.setState({
			filteredBHUList: filteredBHUList,
			BHUId: filteredSelectedBHU,
			filteredRHCList: filteredRHCList,
			RHCId: filteredSelectedRHC,
			filteredXpertSiteList: filteredXpertSiteList,
			XpertSiteId: filteredSelectedXpertSite,
		});
	};

	ShowHideFilters = () => {
		this.setState({
			showFilters: !this.state.showFilters,
		});
	};

	printDashboard = () => {
		$("#Componentprintlink").click();
	};

	GetPageConfigData = (CallBack) => {
		this.props.ShowLoader({ Isloading: true });
		var d1 = $.Deferred();
		var d2 = $.Deferred();
		var d3 = $.Deferred();
		var d4 = $.Deferred();
		var d5 = $.Deferred();

		this.SelectProvinces(() => {
			d1.resolve();
		});
		this.SelectDistricts(() => {
			d2.resolve();
		});
		this.SelectTehsil(() => {
			d3.resolve();
		});
		this.SelectHCF(() => {
			d4.resolve();
		});
		this.SelectXpertSites(() => {
			d5.resolve();
		});

		$.when(d1, d2, d3, d4, d5).done(() => {
			this.props.ShowLoader({ Isloading: false });
			CallBack();
		});
	};
	SelectSubReciepents = () => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectALl_SubRecipient,
			{},
			(resp) => {
				if (resp.status) {
					this.setState({
						SrList: resp.data.map((d) => ({
							id: d.id,
							name: d.short_name,
							...d,
						})),
					});
				}
			}
		);
	};
	SelectTBRegisteredPatients = async (Callback) => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.BaseUrlAPI + "/api/Patients/TBRegisteredPatients",
			{},
			(resp) => {
				if (resp.status) {
					this.setState({
						TbRegisteredPatients: resp.data[0].registeredPatients,
					});
					if (Callback) Callback();
				}
			}
		);
	};
	SelectFunctionNonFunctionRiders = (Callback) => {
		var datesArrayRider = [];
		datesArrayRider[0] = moment(new Date()).toDate();
		datesArrayRider[1] = moment(new Date()).subtract(1, "days").toDate();
		datesArrayRider[2] = moment(new Date()).subtract(2, "days").toDate();
		datesArrayRider[3] = moment(new Date()).subtract(3, "days").toDate();
		datesArrayRider[4] = moment(new Date()).subtract(4, "days").toDate();
		datesArrayRider[5] = moment(new Date()).subtract(5, "days").toDate();
		var templastRider = new Date(datesArrayRider[5]);
		datesArrayRider[6] = new Date(
			templastRider.setDate(templastRider.getDate() - 1)
		);

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.BaseUrlAPI + "/api/Rider/FunctionNonFunctionalRiders",
			{
				fromDate: Common.ConvertToUtcDateTime(
					Common.getOnlyDate(datesArrayRider[5]) + " 00:00:00"
				),
				toDate: Common.ConvertToUtcDateTime(
					Common.getOnlyDate(datesArrayRider[0]) + " 23:59:59"
				),
			},
			(data) => {
				this.setState({
					FunctionRiders: data.data?.[0],
				});
			},
			(error) => {
				if (Callback) Callback();
				this.props.ShowAlert({
					Type: 0,
					Msg: "unable to fetch riders.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	SelectProvinces = (Callback) => {
		this.setState({ ProvinceLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Province,
			{},
			(data) => {
				this.setState({
					ProvinceLoader: false,
					Provincelist: data.data.sort(Common.compare),
				});
				if (Callback) Callback();
			},
			(error) => {
				if (Callback) Callback();
				this.props.ShowAlert({
					Type: 0,
					Msg: ".",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	SelectDistricts = (Callback) => {
		this.setState({ DistrictLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_District,
			{},
			(data) => {
				this.setState({
					DistrictLoader: false,

					Districtlist: data.data.sort(Common.compare),
				});
				if (Callback) Callback();
			},
			(error) => {
				this.setState({ DistrictLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				if (Callback) Callback();
			}
		);
	};
	SelectTehsil = (Callback) => {
		this.setState({ TehsilLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Tehsil,
			{},
			(data) => {
				this.setState({
					TehsilLoader: false,
					Tehsillist: data.data.sort(Common.compare),
				});
				if (Callback) Callback();
			},
			(error) => {
				this.setState({ TehsilLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				if (Callback) Callback();
			}
		);
	};
	SelectHCF = (Callback) => {
		this.setState({ HCFLoader: true });
		Common.Ajax(
			this.props.UserAuthentication?.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_HCF,
			{
				fromDate: Common.ConvertToUtcDateTime(
					Common.getOnlyDate("01/01/2019") + " 00:00:00"
				),
				toDate: Common.ConvertToUtcDateTime(
					Common.getOnlyDate("01/01/2030") + " 23:59:59"
				),
			},
			(data) => {
				var BHUList = [];
				var RHCList = [];
				for (var i = 0; i < data.data.length; i++) {
					if (data.data[i].typeId === 1) {
						BHUList.push(data.data[i]);
					} else {
						RHCList.push(data.data[i]);
					}
				}
				this.setState({
					HCFList: data.data,
					BHUList: BHUList,
					RHCList: RHCList,
					HCFLoader: false,
				});
				if (Callback) Callback();
			},
			(error) => {
				this.setState({ HCFLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				if (Callback) Callback();
			}
		);
	};
	SelectXpertSites = (Callback) => {
		this.setState({ XpertSiteLoader: true });
		Common.Ajax(
			this.props.UserAuthentication?.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_XpertSites,
			{},
			(data) => {
				this.setState({
					XpertSiteLoader: false,
					XpertSitelist: data.data,
				});
				if (Callback) Callback();
			},
			(error) => {
				this.setState({ XpertSiteLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				if (Callback) Callback();
			}
		);
	};
	handlePieChartViewTypeChange = () => {
		this.props.ShowLoader({ Isloading: true });
		this.SelectPieChartStats(() => {
			this.props.ShowLoader({ Isloading: false });
		});
	};

	GetDashboardStats = async () => {
		this.props.ShowLoader({ Isloading: true });

		const d1 = $.Deferred();
		const d2 = $.Deferred();
		const d3 = $.Deferred();
		const d4 = $.Deferred();
		const d5 = $.Deferred();
		const d6 = $.Deferred();
		const d7 = $.Deferred();

		this.SelectCradsStats(() => d1.resolve());
		this.SelectLineChartStats(() => d2.resolve());
		this.SelectBarsChartStats(() => d3.resolve());
		this.SelectBarsChartSubResciopientStats(() => d4.resolve());
		this.SelectActiveInactiveHCF(() => d5.resolve());
		this.SelectTBRegisteredPatients(() => d6.resolve());
		this.SelectPieChartStats(() => d7.resolve());

		$.when(d1, d2, d3, d4, d5, d6, d7).done(() => {
			this.props.ShowLoader({ Isloading: false });
		});
	};

	SelectCradsStats = async (CallBack) => {
		var povinceIdString =
			this.state.ProvinceId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
		var districtIdString =
			this.state.DistrictId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
		var tehsilIdString =
			this.state.TehsilId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";
		var bhuIdString =
			this.state.BHUId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.BHUId, "id") + ",";
		var rhcIdString =
			this.state.RHCId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.RHCId, "id") + ",";
		var xpertIdString =
			this.state.XpertSiteId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.XpertSiteId, "id") + ",";

		var bhuIdList = [];
		if (this.state.BHUId.length > 0) {
			for (var i in this.state.BHUId) {
				let obj = {
					datastring: this.state.BHUId[i].id,
				};
				bhuIdList.push(obj);
			}
		}

		var rhcIdList = [];
		if (this.state.RHCId.length > 0) {
			for (var i in this.state.RHCId) {
				let obj = {
					datastring: this.state.RHCId[i].id,
				};
				rhcIdList.push(obj);
			}
		}

		var Parameters = {
			fromDate: Common.ConvertToUtcDateTimeNew(
				Common.getOnlyDate(this.state.startDate) + " 00:00:00"
			),
			toDate: Common.ConvertToUtcDateTimeNew(
				Common.getOnlyDate(this.state.endDate) + " 23:59:59"
			),
			getType: 1,
			srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
			povinceIdString: povinceIdString,
			districtIdString: districtIdString,
			tehsilIdString: tehsilIdString,
			bhuIdString: bhuIdString,
			rhcIdString: rhcIdString,
			xpertIdString: xpertIdString,
			active: this.state.active,
			bhuIdList: bhuIdList,
			rhcIdList: rhcIdList,
			isSaveSearch: this.state.isSaveSearch,
			category: this.state.category === "" ? null : this.state.category,
			lowerAge: this.state.startAge,
			upperAge: this.state.endAge,
			ismicroscope: this.state.isMicroscope ? 1 : null,
			gender: $("#gender").val() === "" ? null : $("#gender").val(),
		};

		const d1 = $.Deferred();
		const d2 = $.Deferred();
		const d3 = $.Deferred();
		const d4 = $.Deferred();
		const d5 = $.Deferred();
		const d6 = $.Deferred();
		const d7 = $.Deferred();
		const d8 = $.Deferred();
		const d9 = $.Deferred();
		const d10 = $.Deferred();
		const d11 = $.Deferred();
		const d12 = $.Deferred();

		this.getTotalSamplesStats(Parameters, () => d1.resolve());

		$.when(d1).done(() => {
			this.getSamplesAssignedToRiderStats(Parameters, () => d2.resolve());
			$.when(d2).done(() => {
				this.getTransportedSamplesStats(Parameters, () => d3.resolve());
				$.when(d3).done(() => {
					this.getTransportedAndTestedSamplesStats(Parameters, () =>
						d4.resolve()
					);
					$.when(d4).done(() => {
						this.getAfbPositiveCasesStats(Parameters, () => d5.resolve());
						$.when(d5).done(() => {
							this.getMTBDetectedCasesStats(Parameters, () => d6.resolve());
							$.when(d6).done(() => {
								this.getRRDetectedCasesStats(Parameters, () => d7.resolve());
								$.when(d7).done(() => {
									this.getTurnArroundTimeStats(Parameters, () => d8.resolve());
									$.when(d8).done(() => {
										this.getCostTransportedSampleStats(Parameters, () =>
											d9.resolve()
										);
										$.when(d9).done(() => {
											this.getGXSitesStats(Parameters, () => d10.resolve());
											$.when(d10).done(() => {
												this.getDistricsRidersStats(Parameters, () =>
													d11.resolve()
												);
												$.when(d11).done(() => {
													this.getHealthCareFacilitiesStats(Parameters, () =>
														d12.resolve()
													);
												});
											});
										});
									});
								});
							});
						});
					});
				});
			});
		});

		CallBack();
	};

	getTotalSamplesStats = (Parameters, CallBack) => {
		this.setState({ SR_loading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.TotalSamplesStats,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						SR_totalSamples: resp.data.totalSamples,
						SR_bhUs: resp.data.bhUs,
						SR_rhCs: resp.data.rhCs,
						SR_gPs: resp.data.gPs,
						SR_ppmLabs: resp.data.ppmLabs,
						SR_loading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ SR_loading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	getSamplesAssignedToRiderStats = (Parameters, CallBack) => {
		this.setState({ SATR_loading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.SamplesAssignedToRiderStats,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						SATR_totalSamples: resp.data.totalSamples,
						SATR_totalIncentivesForCompletedRides: resp.data.totalIncentivesForCompletedRides,
						SATR_completedRides: resp.data.completedRides,
						//SATR_bhUs: resp.data.bhUs,
						//SATR_rhCs: resp.data.rhCs,
						//SATR_gPs: resp.data.gPs,
						//SATR_ppmLabs: resp.data.ppmLabs,
						SATR_loading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ SATR_loading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	getTransportedSamplesStats = (Parameters, CallBack) => {
		this.setState({ TS_loading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.TransportedSamplesStats,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						TS_totalSamples: resp.data.totalSamples,
						TS_bhUs: resp.data.bhUs,
						TS_rhCs: resp.data.rhCs,
						TS_gPs: resp.data.gPs,
						TS_ppmLabs: resp.data.ppmLabs,
						TS_loading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ TS_loading: false });

				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	getTransportedAndTestedSamplesStats = (Parameters, CallBack) => {
		this.setState({ TATS_loading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.TransportedAndTestedSamplesStats,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						TATS_totalSamples:
							resp.data.bhUs +
							resp.data.rhCs +
							resp.data.gPs +
							resp.data.ppmLabs,
						TATS_bhUs: resp.data.bhUs,
						TATS_rhCs: resp.data.rhCs,
						TATS_gPs: resp.data.gPs,
						TATS_ppmLabs: resp.data.ppmLabs,
						TATS_loading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ TATS_loading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	getAfbPositiveCasesStats = (Parameters, CallBack) => {
		this.setState({ afbloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.AFB_PositiveCasesStats,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						afbPositiveSamples: resp.data.afbPositiveSamples,
						afbTestedSamples: resp.data.afbTestedSamples,
						samplesTransportedForAFBTest:
							resp.data.samplesTransportedForAFBTest,
						afbAverageCost:
							resp.data.afbAverageCost / resp.data.afbPositiveSamples,
						afbloading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ afbloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	getMTBDetectedCasesStats = (Parameters, CallBack) => {
		this.setState({ mtbloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.MTB_DetectedCasesStats,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						gxTestedSamples: resp.data.gxTestedSamples,
						mtbDetectedSamples: resp.data.mtbDetectedSamples,
						samplesTransportedForGXTest: resp.data.samplesTransportedForGXTest,
						mtbAverageCost:
							resp.data.mtbAverageCost / resp.data.mtbDetectedSamples,
						mtbloading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ mtbloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	getRRDetectedCasesStats = (Parameters, CallBack) => {
		this.setState({ rr_loading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.RR_DetectedCasesStats,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						rr_gxTestedSamples: resp.data.gxTestedSamples,
						rr_mtbDetectedSamples: resp.data.mtbDetectedSamples,
						rr_DetectedSamples: resp.data.rrDetectedSamples,
						rr_AverageCost:
							resp.data.rrAverageCost / resp.data.rrDetectedSamples,
						rr_loading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ rr_loading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	getTurnArroundTimeStats = (Parameters, CallBack) => {
		this.setState({ turnAroundTimeloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.TurnArroundTime,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						turnAroundTimeAFBTesting: resp.data.turnAroundTimeAFBTesting,
						turnAroundTimeGXTesting: resp.data.turnAroundTimeGXTesting,
						turnAroundTimeTransportation:
							resp.data.turnAroundTimeTransportation,
						turnAroundTimeloading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ turnAroundTimeloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	getCostTransportedSampleStats = (Parameters, CallBack) => {
		this.setState({ bhuloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.CostTransportedSample,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						bhus: resp.data.bhus,
						gps: resp.data.gps,
						ppmlabs: resp.data.ppmlabs,
						rhcs: resp.data.rhcs,
						bhuloading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ bhuloading: false });

				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	getGXSitesStats = (Parameters, CallBack) => {
		this.setState({ GXSitesloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.GXSitesCount,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						activePrivateGXSites: resp.data.activePrivateGXSites,
						activePublicGXSites: resp.data.activePublicGXSites,
						samplesTestedPrivateGX: resp.data.samplesTestedPrivateGX,
						samplesTestedPublicGX: resp.data.samplesTestedPublicGX,
						totalPrivateGXSites: resp.data.totalPrivateGXSites,
						totalPublicGXSites: resp.data.totalPublicGXSites,
						GXSitesloading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ GXSitesloading: false });

				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	getDistricsRidersStats = (Parameters, CallBack) => {
		this.setState({ RD_loading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.DistrictRidersCount,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						activeDistricts: resp.data.activeDistricts,
						activeRidersCVR: resp.data.activeRidersCVR,
						activeRidersProjectStaff: resp.data.activeRidersProjectStaff,
						activeRidersPublicServant: resp.data.activeRidersPublicServant,
						totalDistricts: resp.data.totalDistricts,
						totalRidersCVR: resp.data.totalRidersCVR,
						totalRidersProjectStaff: resp.data.totalRidersProjectStaff,
						totalRidersPublicServant: resp.data.totalRidersPublicServant,
						RD_loading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ RD_loading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	getHealthCareFacilitiesStats = (Parameters, CallBack) => {
		this.setState({ activeLoading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.HCFCount,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					this.setState({
						activeBHU: resp.data.activeBHU,
						activeGP: resp.data.activeGP,
						activePPMLabs: resp.data.activePPMLabs,
						activeRHC: resp.data.activeRHC,
						totalBHU: resp.data.totalBHU,
						totalGP: resp.data.totalGP,
						totalPPMlabs: resp.data.totalPPMlabs,
						totalRHC: resp.data.totalRHC,
						activeLoading: false,
					});
					if (this.state.isSaveSearch) {
						SyncConfig(
							() => { },
							() => { }
						);
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.setState({ activeLoading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	SelectActiveInactiveHCF = async (Callback) => {
		var datesArr = [];
		datesArr[0] = moment(new Date()).toDate();
		datesArr[1] = moment(new Date()).subtract(1, "days").toDate();
		datesArr[2] = moment(new Date()).subtract(2, "days").toDate();
		datesArr[3] = moment(new Date()).subtract(3, "days").toDate();
		datesArr[4] = moment(new Date()).subtract(4, "days").toDate();
		datesArr[5] = moment(new Date()).subtract(5, "days").toDate();
		var templast = new Date(datesArr[5]);
		datesArr[6] = new Date(templast.setDate(templast.getDate() - 1));

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.BaseUrlAPI + "/api/HCF/ActiveInActiveHCFCount",
			{
				fromDate: Common.ConvertToUtcDateTime(
					Common.getOnlyDate(datesArr[5]) + " 00:00:00"
				),
				toDate: Common.ConvertToUtcDateTime(
					Common.getOnlyDate(datesArr[0]) + " 23:59:59"
				),
			},
			(resp) => {
				if (resp.status) {
					this.setState({
						ActiveHCF: resp.data[0] ? resp.data[0].activeHCF : 0,
						InactiveHCF: resp.data[0] ? resp.data[0].inActiveHCF : 0,
						activeDistricts: resp.data[0] ? resp.data[0].activeDistrict : 0,
						inActiveDistricts: resp.data[0] ? resp.data[0].inactiveDistrict : 0,
					});
					try {
						Callback();
					} catch (error) { }
				}
			}
		);
	};

	SelectActiveInactiveXpertSite = () => {
		var datesArr = [];
		datesArr[0] = moment(new Date()).toDate();
		datesArr[1] = moment(new Date()).subtract(1, "days").toDate();
		datesArr[2] = moment(new Date()).subtract(2, "days").toDate();
		datesArr[3] = moment(new Date()).subtract(3, "days").toDate();
		datesArr[4] = moment(new Date()).subtract(4, "days").toDate();
		datesArr[5] = moment(new Date()).subtract(5, "days").toDate();
		var templast = new Date(datesArr[5]);
		datesArr[6] = new Date(templast.setDate(templast.getDate() - 1));

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.BaseUrlAPI + "/api/XpertSite/ActiveInActiveXpertSiteCount",
			{
				fromDate: Common.ConvertToUtcDateTime(
					Common.getOnlyDate(datesArr[5]) + " 00:00:00"
				),
				toDate: Common.ConvertToUtcDateTime(
					Common.getOnlyDate(datesArr[0]) + " 23:59:59"
				),
			},
			(resp) => {
				if (resp.status) {
					this.setState({
						ActiveXpert: resp.data[0] ? resp.data[0].activeXpertSite : 0,
						InactiveXpert: resp.data[0] ? resp.data[0].inActiveXpertSite : 0,
					});
				}
			}
		);
	};

	SelectLineChartStats = async (CallBack) => {
		var datesArr = [];
		datesArr[0] = moment(new Date()).toDate();
		datesArr[1] = moment(new Date()).subtract(1, "days").toDate();
		datesArr[2] = moment(new Date()).subtract(2, "days").toDate();
		datesArr[3] = moment(new Date()).subtract(3, "days").toDate();
		datesArr[4] = moment(new Date()).subtract(4, "days").toDate();
		datesArr[5] = moment(new Date()).subtract(5, "days").toDate();
		// datesArr[0] = Common.GetWeekDaysDate(new Date(), "Monday")
		// datesArr[1] = Common.GetWeekDaysDate(new Date(), "Tuesday")
		// datesArr[2] = Common.GetWeekDaysDate(new Date(), "Wednesday")
		// datesArr[3] = Common.GetWeekDaysDate(new Date(), "Thursday")
		// datesArr[4] = Common.GetWeekDaysDate(new Date(), "Friday")
		// datesArr[5] = Common.GetWeekDaysDate(new Date(), "Saturday")
		var templast = new Date(datesArr[5]);
		datesArr[6] = new Date(templast.setDate(templast.getDate() - 1));

		var LineChartData = [
			[
				"Days",
				"Sample received",
				"RR cases",
				"MTB cases",
				"AFB Positive cases",
				"AFB Negative cases",
			],
			[Common.GetDateMonthViewDate(datesArr[6]), 0, 0, 0, 0, 0],
			[Common.GetDateMonthViewDate(datesArr[5]), 0, 0, 0, 0, 0],
			[Common.GetDateMonthViewDate(datesArr[4]), 0, 0, 0, 0, 0],
			[Common.GetDateMonthViewDate(datesArr[3]), 0, 0, 0, 0, 0],
			[Common.GetDateMonthViewDate(datesArr[2]), 0, 0, 0, 0, 0],
			[Common.GetDateMonthViewDate(datesArr[1]), 0, 0, 0, 0, 0],
			[Common.GetDateMonthViewDate(datesArr[0]), 0, 0, 0, 0, 0],
		];

		var povinceIdString =
			this.state.ProvinceId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
		var districtIdString =
			this.state.DistrictId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
		var tehsilIdString =
			this.state.TehsilId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";
		var bhuIdString =
			this.state.BHUId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.BHUId, "id") + ",";
		var rhcIdString =
			this.state.RHCId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.RHCId, "id") + ",";
		var xpertIdString =
			this.state.XpertSiteId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.XpertSiteId, "id") + ",";

		var bhuIdList = [];
		if (this.state.BHUId.length > 0) {
			for (var i in this.state.BHUId) {
				let obj = {
					datastring: this.state.BHUId[i].id,
				};
				bhuIdList.push(obj);
			}
		}

		var rhcIdList = [];
		if (this.state.RHCId.length > 0) {
			for (var i in this.state.RHCId) {
				let obj = {
					datastring: this.state.RHCId[i].id,
				};
				rhcIdList.push(obj);
			}
		}

		var Parameters = {
			fromDate: Common.ConvertToUtcDateTime(
				Common.getOnlyDate(datesArr[5]) + " 00:00:00"
			),
			toDate: Common.ConvertToUtcDateTime(
				Common.getOnlyDate(datesArr[0]) + " 23:59:59"
			),
			getType: 1,
			srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
			povinceIdString: povinceIdString,
			districtIdString: districtIdString,
			tehsilIdString: tehsilIdString,
			bhuIdString: bhuIdString,
			rhcIdString: rhcIdString,
			active: this.state.active,
			xpertIdString: xpertIdString,
			category: this.state.category === "" ? null : this.state.category,
			lowerAge: this.state.startAge,
			upperAge: this.state.endAge,
			gender: $("#gender").val() === "" ? null : $("#gender").val(),
			bhuIdList: bhuIdList,
			rhcIdList: rhcIdList,
			ismicroscope: this.state.isMicroscope ? 1 : null,
			isSaveSearch: this.state.isSaveSearch,
		};
		CallBack();
		// Common.Ajax(
		// 	this.props.UserAuthentication.AuthToken,
		// 	"POST",
		// 	false,
		// 	Common.APILinks.Select_LineChartStats,
		// 	JSON.stringify(Parameters),
		// 	(resp) => {
		// 		if (resp.status) {
		// 			var receivedArr = [];
		// 			// var deliveredArr=[]
		// 			var rrArr = [];
		// 			var MTBArr = [];
		// 			var AFBPositiveArr = [];
		// 			var AFBNegativeArr = [];

		// 			var firstStart = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[6]) + " 00:00:00"
		// 					)
		// 				)
		// 			);
		// 			var firstEnd = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[6]) + " 23:59:59"
		// 					)
		// 				)
		// 			);
		// 			var secondStart = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[5]) + " 00:00:00"
		// 					)
		// 				)
		// 			);
		// 			var secondEnd = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[5]) + " 23:59:59"
		// 					)
		// 				)
		// 			);
		// 			var thirdStart = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[4]) + " 00:00:00"
		// 					)
		// 				)
		// 			);
		// 			var thirdEnd = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[4]) + " 23:59:59"
		// 					)
		// 				)
		// 			);
		// 			var fourthStart = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTime(
		// 						Common.getOnlyDate(datesArr[3]) + " 00:00:00"
		// 					)
		// 				)
		// 			);
		// 			var fourthEnd = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[3]) + " 23:59:59"
		// 					)
		// 				)
		// 			);
		// 			var fifthStart = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[2]) + " 00:00:00"
		// 					)
		// 				)
		// 			);
		// 			var fifthEnd = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[2]) + " 23:59:59"
		// 					)
		// 				)
		// 			);
		// 			var sixthStart = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[1]) + " 00:00:00"
		// 					)
		// 				)
		// 			);
		// 			var sixthEnd = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[1]) + " 23:59:59"
		// 					)
		// 				)
		// 			);
		// 			var seventhStart = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[0]) + " 00:00:00"
		// 					)
		// 				)
		// 			);
		// 			var seventhEnd = new Date(
		// 				Common.ConvertToLocalDateTime(
		// 					Common.ConvertToUtcDateTimeNew(
		// 						Common.getOnlyDate(datesArr[0]) + " 23:59:59"
		// 					)
		// 				)
		// 			);

		// 			// populate arrays
		// 			for (var i = 0; i < resp.data.length; i++) {
		// 				if (resp.data[i].type === "received") {
		// 					receivedArr.push(resp.data[i]);
		// 				}
		// 				// else if (resp.data[i].type=="delivered")
		// 				// {
		// 				//   deliveredArr.push(resp.data[i])
		// 				// }
		// 				else if (resp.data[i].type === "rr") {
		// 					rrArr.push(resp.data[i]);
		// 				} else if (resp.data[i].type === "mtb") {
		// 					MTBArr.push(resp.data[i]);
		// 				} else if (resp.data[i].type === "afbPositive") {
		// 					AFBPositiveArr.push(resp.data[i]);
		// 				} else if (resp.data[i].type === "afbNegative") {
		// 					AFBNegativeArr.push(resp.data[i]);
		// 				}
		// 			}

		// 			// Get received count
		// 			for (var i = 0; i < receivedArr.length; i++) {
		// 				let rowtemdate = new Date(
		// 					Common.ConvertToLocalDateTime(receivedArr[i].date)
		// 				);
		// 				if (firstStart <= rowtemdate && rowtemdate <= firstEnd) {
		// 					LineChartData[1][1] = LineChartData[1][1] + 1;
		// 				}
		// 				if (secondStart <= rowtemdate && rowtemdate <= secondEnd) {
		// 					LineChartData[2][1] = LineChartData[2][1] + 1;
		// 				}
		// 				if (thirdStart <= rowtemdate && rowtemdate <= thirdEnd) {
		// 					LineChartData[3][1] = LineChartData[3][1] + 1;
		// 				}
		// 				if (fourthStart <= rowtemdate && rowtemdate <= fourthEnd) {
		// 					LineChartData[4][1] = LineChartData[4][1] + 1;
		// 				}
		// 				if (fifthStart <= rowtemdate && rowtemdate <= fifthEnd) {
		// 					LineChartData[5][1] = LineChartData[5][1] + 1;
		// 				}
		// 				if (sixthStart <= rowtemdate && rowtemdate <= sixthEnd) {
		// 					LineChartData[6][1] = LineChartData[6][1] + 1;
		// 				}
		// 				if (seventhStart <= rowtemdate && rowtemdate <= seventhEnd) {
		// 					LineChartData[7][1] = LineChartData[7][1] + 1;
		// 				}
		// 			}

		// 			// Get RR Result count
		// 			for (var i = 0; i < rrArr.length; i++) {
		// 				let rowtemdate = new Date(
		// 					Common.ConvertToLocalDateTime(rrArr[i].date)
		// 				);
		// 				if (firstStart <= rowtemdate && rowtemdate <= firstEnd) {
		// 					LineChartData[1][2] = LineChartData[1][2] + 1;
		// 				}
		// 				if (secondStart <= rowtemdate && rowtemdate <= secondEnd) {
		// 					LineChartData[2][2] = LineChartData[2][2] + 1;
		// 				}
		// 				if (thirdStart <= rowtemdate && rowtemdate <= thirdEnd) {
		// 					LineChartData[3][2] = LineChartData[3][2] + 1;
		// 				}
		// 				if (fourthStart <= rowtemdate && rowtemdate <= fourthEnd) {
		// 					LineChartData[4][2] = LineChartData[4][2] + 1;
		// 				}
		// 				if (fifthStart <= rowtemdate && rowtemdate <= fifthEnd) {
		// 					LineChartData[5][2] = LineChartData[5][2] + 1;
		// 				}
		// 				if (sixthStart <= rowtemdate && rowtemdate <= sixthEnd) {
		// 					LineChartData[6][2] = LineChartData[6][2] + 1;
		// 				}
		// 				if (seventhStart <= rowtemdate && rowtemdate <= seventhEnd) {
		// 					LineChartData[7][2] = LineChartData[7][2] + 1;
		// 				}
		// 			}

		// 			// // Get deliveredArr count
		// 			// for(var i=0;i<deliveredArr.length;i++)
		// 			// {
		// 			//   let rowtemdate=new Date(Common.ConvertToLocalDateTime(deliveredArr[i].date))
		// 			//   if (firstStart <= rowtemdate && rowtemdate <= firstEnd )
		// 			//   {
		// 			//     LineChartData[1][2]= LineChartData[1][2] + 1
		// 			//   }
		// 			//   if (secondStart <= rowtemdate && rowtemdate <= secondEnd )
		// 			//   {
		// 			//     LineChartData[2][2]= LineChartData[2][2] + 1
		// 			//   }
		// 			//   if (thirdStart <= rowtemdate && rowtemdate <= thirdEnd )
		// 			//   {
		// 			//     LineChartData[3][2]= LineChartData[3][2] + 1
		// 			//   }
		// 			//   if (fourthStart <= rowtemdate && rowtemdate <= fourthEnd )
		// 			//   {
		// 			//     LineChartData[4][2]= LineChartData[4][2] + 1
		// 			//   }
		// 			//   if (fifthStart <= rowtemdate && rowtemdate <= fifthEnd )
		// 			//   {
		// 			//     LineChartData[5][2]= LineChartData[5][2] + 1
		// 			//   }
		// 			//   if (sixthStart <= rowtemdate && rowtemdate <= sixthEnd )
		// 			//   {
		// 			//     LineChartData[6][2]= LineChartData[6][2] + 1
		// 			//   }
		// 			//   if (seventhStart <= rowtemdate && rowtemdate <= seventhEnd )
		// 			//   {
		// 			//     LineChartData[7][2]= LineChartData[7][2] + 1
		// 			//   }
		// 			// }

		// 			// Get MTBArr count
		// 			for (var i = 0; i < MTBArr.length; i++) {
		// 				let rowtemdate = new Date(
		// 					Common.ConvertToLocalDateTime(MTBArr[i].date)
		// 				);
		// 				if (firstStart <= rowtemdate && rowtemdate <= firstEnd) {
		// 					LineChartData[1][3] = LineChartData[1][3] + 1;
		// 				}
		// 				if (secondStart <= rowtemdate && rowtemdate <= secondEnd) {
		// 					LineChartData[2][3] = LineChartData[2][3] + 1;
		// 				}
		// 				if (thirdStart <= rowtemdate && rowtemdate <= thirdEnd) {
		// 					LineChartData[3][3] = LineChartData[3][3] + 1;
		// 				}
		// 				if (fourthStart <= rowtemdate && rowtemdate <= fourthEnd) {
		// 					LineChartData[4][3] = LineChartData[4][3] + 1;
		// 				}
		// 				if (fifthStart <= rowtemdate && rowtemdate <= fifthEnd) {
		// 					LineChartData[5][3] = LineChartData[5][3] + 1;
		// 				}
		// 				if (sixthStart <= rowtemdate && rowtemdate <= sixthEnd) {
		// 					LineChartData[6][3] = LineChartData[6][3] + 1;
		// 				}
		// 				if (seventhStart <= rowtemdate && rowtemdate <= seventhEnd) {
		// 					LineChartData[7][3] = LineChartData[7][3] + 1;
		// 				}
		// 			}

		// 			// Get AFBPositiveArr count
		// 			for (var i = 0; i < AFBPositiveArr.length; i++) {
		// 				let rowtemdate = new Date(
		// 					Common.ConvertToLocalDateTime(AFBPositiveArr[i].date)
		// 				);
		// 				if (firstStart <= rowtemdate && rowtemdate <= firstEnd) {
		// 					LineChartData[1][4] = LineChartData[1][4] + 1;
		// 				}
		// 				if (secondStart <= rowtemdate && rowtemdate <= secondEnd) {
		// 					LineChartData[2][4] = LineChartData[2][4] + 1;
		// 				}
		// 				if (thirdStart <= rowtemdate && rowtemdate <= thirdEnd) {
		// 					LineChartData[3][4] = LineChartData[3][4] + 1;
		// 				}
		// 				if (fourthStart <= rowtemdate && rowtemdate <= fourthEnd) {
		// 					LineChartData[4][4] = LineChartData[4][4] + 1;
		// 				}
		// 				if (fifthStart <= rowtemdate && rowtemdate <= fifthEnd) {
		// 					LineChartData[5][4] = LineChartData[5][4] + 1;
		// 				}
		// 				if (sixthStart <= rowtemdate && rowtemdate <= sixthEnd) {
		// 					LineChartData[6][4] = LineChartData[6][4] + 1;
		// 				}
		// 				if (seventhStart <= rowtemdate && rowtemdate <= seventhEnd) {
		// 					LineChartData[7][4] = LineChartData[7][4] + 1;
		// 				}
		// 			}

		// 			// Get AFBNegativeArr count
		// 			for (var i = 0; i < AFBNegativeArr.length; i++) {
		// 				let rowtemdate = new Date(
		// 					Common.ConvertToLocalDateTime(AFBNegativeArr[i].date)
		// 				);
		// 				if (firstStart <= rowtemdate && rowtemdate <= firstEnd) {
		// 					LineChartData[1][5] = LineChartData[1][5] + 1;
		// 				}
		// 				if (secondStart <= rowtemdate && rowtemdate <= secondEnd) {
		// 					LineChartData[2][5] = LineChartData[2][5] + 1;
		// 				}
		// 				if (thirdStart <= rowtemdate && rowtemdate <= thirdEnd) {
		// 					LineChartData[3][5] = LineChartData[3][5] + 1;
		// 				}
		// 				if (fourthStart <= rowtemdate && rowtemdate <= fourthEnd) {
		// 					LineChartData[4][5] = LineChartData[4][5] + 1;
		// 				}
		// 				if (fifthStart <= rowtemdate && rowtemdate <= fifthEnd) {
		// 					LineChartData[5][5] = LineChartData[5][5] + 1;
		// 				}
		// 				if (sixthStart <= rowtemdate && rowtemdate <= sixthEnd) {
		// 					LineChartData[6][5] = LineChartData[6][5] + 1;
		// 				}
		// 				if (seventhStart <= rowtemdate && rowtemdate <= seventhEnd) {
		// 					LineChartData[7][5] = LineChartData[7][5] + 1;
		// 				}
		// 			}

		// 			this.setState({
		// 				LineChartData: LineChartData,
		// 			});
		// 		} else {
		// 			this.props.ShowAlert({ Type: 0, Msg: resp.message });
		// 			setTimeout(function () {
		// 				$("#Alertmsgbtn").click();
		// 			}, 50);
		// 		}
		// 		CallBack();
		// 	},
		// 	(error) => {
		// 		CallBack();
		// 		this.props.ShowAlert({
		// 			Type: 0,
		// 			Msg: "Something went wrong, please try again.",
		// 		});
		// 		setTimeout(function () {
		// 			$("#Alertmsgbtn").click();
		// 		}, 50);
		// 	}
		// );
	};
	SelectPieChartStats = async (CallBack) => {
		var povinceIdString =
			this.state.ProvinceId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
		var districtIdString =
			this.state.DistrictId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
		var tehsilIdString =
			this.state.TehsilId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";
		var bhuIdString =
			this.state.BHUId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.BHUId, "id") + ",";
		var rhcIdString =
			this.state.RHCId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.RHCId, "id") + ",";
		var xpertIdString =
			this.state.XpertSiteId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.XpertSiteId, "id") + ",";

		var bhuIdList = [];
		if (this.state.BHUId.length > 0) {
			for (var i in this.state.BHUId) {
				let obj = {
					datastring: this.state.BHUId[i].id,
				};
				bhuIdList.push(obj);
			}
		}

		var rhcIdList = [];
		if (this.state.RHCId.length > 0) {
			for (var i in this.state.RHCId) {
				let obj = {
					datastring: this.state.RHCId[i].id,
				};
				rhcIdList.push(obj);
			}
		}

		var pieChartType = $("#PieChartTypeVal");

		var Parameters = {
			fromDate: Common.ConvertToUtcDateTime(
				Common.getOnlyDate(this.state.startDate) + " 00:00:00"
			),
			toDate: Common.ConvertToUtcDateTime(
				Common.getOnlyDate(this.state.endDate) + " 23:59:59"
			),
			getType: 1,
			srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
			dataType: pieChartType.val() ? pieChartType.val() : "",
			povinceIdString: povinceIdString,
			districtIdString: districtIdString,
			tehsilIdString: tehsilIdString,
			active: this.state.active,
			category: this.state.category === "" ? null : this.state.category,
			lowerAge: this.state.startAge,
			upperAge: this.state.endAge,
			gender: $("#gender").val() === "" ? null : $("#gender").val(),
			bhuIdString: bhuIdString,
			rhcIdString: rhcIdString,
			xpertIdString: xpertIdString,
			bhuIdList: bhuIdList,
			rhcIdList: rhcIdList,
			//ismicroscope: this.state.isMicroscope ? 1 : 0,
			isSaveSearch: this.state.isSaveSearch,
		};
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"POST",
			false,
			Common.APILinks.Select_PieChartStatsEf,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					var PieChartData = [["District", "Count"]];
					var ProcessedDistrict = Common.ProcessDataInArray(
						this.state.Districtlist,
						"id"
					);

					for (var i = 0; i < resp.data.length; i++) {
						PieChartData.push([
							ProcessedDistrict[resp.data[i].districtId]?.name,
							resp.data[i].count,
						]);
					}
					this.setState({
						PieChartData: PieChartData,
					});
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				if (CallBack) CallBack();
			},
			(error) => {
				if (CallBack) CallBack();
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	SelectBarsChartSubResciopientStats = async (CallBack) => {
		const datesArr = [];
		datesArr[0] = moment(new Date()).toDate();
		datesArr[1] = moment(new Date()).subtract(1, "days").toDate();
		datesArr[2] = moment(new Date()).subtract(2, "days").toDate();
		datesArr[3] = moment(new Date()).subtract(3, "days").toDate();
		datesArr[4] = moment(new Date()).subtract(4, "days").toDate();
		datesArr[5] = moment(new Date()).subtract(5, "days").toDate();
		const templast = new Date(datesArr[5]);
		datesArr[6] = new Date(templast.setDate(templast.getDate() - 1));

		const Parameters = {
			fromDate: Common.ConvertToUtcDateTime(
				Common.getOnlyDate(datesArr[5]) + " 00:00:00"
			),
			toDate: Common.ConvertToUtcDateTime(
				Common.getOnlyDate(datesArr[0]) + " 23:59:59"
			),
		};

		const params = new URLSearchParams(Parameters).toString();
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			`${Common.APILinks.SelectSubrecipientStats}?${params}`,
			{},
			(resp) => {
				if (resp.status) {
					const subRecepientBarsChartData = resp.data.map((row) => ({
						label: row.subCompleteName,
						value: row.totalsamples,
					}));
					this.setState({ subRecepientBarsChartData });
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	SelectBarsChartStats = async (CallBack) => {
		var datesArr = [];
		datesArr[0] = moment(new Date()).toDate();
		datesArr[1] = moment(new Date()).subtract(1, "days").toDate();
		datesArr[2] = moment(new Date()).subtract(2, "days").toDate();
		datesArr[3] = moment(new Date()).subtract(3, "days").toDate();
		datesArr[4] = moment(new Date()).subtract(4, "days").toDate();
		datesArr[5] = moment(new Date()).subtract(5, "days").toDate();
		var templast = new Date(datesArr[5]);
		datesArr[6] = new Date(templast.setDate(templast.getDate() - 1));

		var BarsChartData = [
			{
				label: Common.GetDateMonthViewDate(datesArr[6]),
				value: "0",
			},
			{
				label: Common.GetDateMonthViewDate(datesArr[5]),
				value: "0",
			},
			{
				label: Common.GetDateMonthViewDate(datesArr[4]),
				value: "0",
			},
			{
				label: Common.GetDateMonthViewDate(datesArr[3]),
				value: "0",
			},
			{
				label: Common.GetDateMonthViewDate(datesArr[2]),
				value: "0",
			},
			{
				label: Common.GetDateMonthViewDate(datesArr[1]),
				value: "0",
			},
			{
				label: Common.GetDateMonthViewDate(datesArr[0]),
				value: "0",
			},
		];

		var povinceIdString =
			this.state.ProvinceId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
		var districtIdString =
			this.state.DistrictId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
		var tehsilIdString =
			this.state.TehsilId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";
		var bhuIdString =
			this.state.BHUId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.BHUId, "id") + ",";
		var rhcIdString =
			this.state.RHCId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.RHCId, "id") + ",";
		var xpertIdString =
			this.state.XpertSiteId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.XpertSiteId, "id") + ",";

		var bhuIdList = [];
		if (this.state.BHUId.length > 0) {
			for (var i in this.state.BHUId) {
				let obj = {
					datastring: this.state.BHUId[i].id,
				};
				bhuIdList.push(obj);
			}
		}

		var rhcIdList = [];
		if (this.state.RHCId.length > 0) {
			for (var i in this.state.RHCId) {
				let obj = {
					datastring: this.state.RHCId[i].id,
				};
				rhcIdList.push(obj);
			}
		}

		var Parameters = {
			fromDate: Common.ConvertToUtcDateTime(
				Common.getOnlyDate(datesArr[5]) + " 00:00:00"
			),
			toDate: Common.ConvertToUtcDateTime(
				Common.getOnlyDate(datesArr[0]) + " 23:59:59"
			),
			getType: 1,
			srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
			povinceIdString: povinceIdString,
			districtIdString: districtIdString,
			tehsilIdString: tehsilIdString,
			bhuIdString: bhuIdString,
			rhcIdString: rhcIdString,
			xpertIdString: xpertIdString,
			category: this.state.category === "" ? null : this.state.category,
			lowerAge: this.state.startAge,
			upperAge: this.state.endAge,
			gender: $("#gender").val() === "" ? null : $("#gender").val(),
			bhuIdList: bhuIdList,
			ismicroscope: this.state.isMicroscope ? 1 : 0,
			rhcIdList: rhcIdList,
			active: this.state.active,
			isSaveSearch: this.state.isSaveSearch,
		};

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.Select_BarsChartStats,
			JSON.stringify(Parameters),
			(resp) => {
				if (resp.status) {
					var firstStart = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[6]) + " 00:00:00"
							)
						)
					);
					var firstEnd = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[6]) + " 23:59:59"
							)
						)
					);
					var secondStart = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[5]) + " 00:00:00"
							)
						)
					);
					var secondEnd = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[5]) + " 23:59:59"
							)
						)
					);
					var thirdStart = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[4]) + " 00:00:00"
							)
						)
					);
					var thirdEnd = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[4]) + " 23:59:59"
							)
						)
					);
					var fourthStart = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[3]) + " 00:00:00"
							)
						)
					);
					var fourthEnd = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[3]) + " 23:59:59"
							)
						)
					);
					var fifthStart = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[2]) + " 00:00:00"
							)
						)
					);
					var fifthEnd = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[2]) + " 23:59:59"
							)
						)
					);
					var sixthStart = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[1]) + " 00:00:00"
							)
						)
					);
					var sixthEnd = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[1]) + " 23:59:59"
							)
						)
					);
					var seventhStart = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[0]) + " 00:00:00"
							)
						)
					);
					var seventhEnd = new Date(
						Common.ConvertToLocalDateTime(
							Common.ConvertToUtcDateTime(
								Common.getOnlyDate(datesArr[0]) + " 23:59:59"
							)
						)
					);
					// console.log({ firstStart, firstEnd, secondStart, secondEnd, thirdStart, thirdEnd, fourthStart, fourthEnd, fifthStart, fifthEnd, sixthStart, sixthEnd, seventhStart, seventhEnd })

					for (var i = 0; i < resp.data.length; i++) {
						let rowtemdate = new Date(
							Common.ConvertToLocalDateTime(resp.data[i].date)
						);
						if (firstStart <= rowtemdate && rowtemdate <= firstEnd) {
							BarsChartData[0].value = (
								parseInt(BarsChartData[0].value) + 1
							).toString();
						}
						if (secondStart <= rowtemdate && rowtemdate <= secondEnd) {
							BarsChartData[1].value = (
								parseInt(BarsChartData[1].value) + 1
							).toString();
						}
						if (thirdStart <= rowtemdate && rowtemdate <= thirdEnd) {
							BarsChartData[2].value = (
								parseInt(BarsChartData[2].value) + 1
							).toString();
						}
						if (fourthStart <= rowtemdate && rowtemdate <= fourthEnd) {
							BarsChartData[3].value = (
								parseInt(BarsChartData[3].value) + 1
							).toString();
						}
						if (fifthStart <= rowtemdate && rowtemdate <= fifthEnd) {
							BarsChartData[4].value = (
								parseInt(BarsChartData[4].value) + 1
							).toString();
						}
						if (sixthStart <= rowtemdate && rowtemdate <= sixthEnd) {
							BarsChartData[5].value = (
								parseInt(BarsChartData[5].value) + 1
							).toString();
						}
						if (seventhStart <= rowtemdate && rowtemdate <= seventhEnd) {
							BarsChartData[6].value = (
								parseInt(BarsChartData[6].value) + 1
							).toString();
						}
					}

					this.setState({
						BarsChartData: BarsChartData,
					});
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				CallBack();
			},
			(error) => {
				CallBack();
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	ResetPageLastSearch = () => {
		this.props.ShowLoader({ Isloading: true });
		var Parameters = {
			pageName: "Dashboard",
		};
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.Reset_PageLastSearch,
			Parameters,
			(resp) => {
				if (resp.status) {
					SyncConfig(
						() => {
							window.location.href = "/Dashboard";
							this.props.ShowLoader({ Isloading: false });
							this.props.ShowAlert({
								Type: 0,
								Msg: "Last saved search reset successfully",
							});
							setTimeout(function () {
								$("#Alertmsgbtn").click();
							}, 50);
						},
						() => {
							this.props.ShowLoader({ Isloading: false });
							this.props.ShowAlert({ Type: 0, Msg: "Error in sync" });
							setTimeout(function () {
								$("#Alertmsgbtn").click();
							}, 50);
						}
					);
				} else {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	render() {
		return (
			<div>
				<MainLayout />
				<div id="right-panel" className="right-panel">
					<Topmenu
						PageTitle="Dashboard"
						showHideFilters={this.ShowHideFilters}
						isShowAddBtn={false}
						isShowPrintBtn={true}
						AddBtnLabel=""
						AddBtnLink=""
					/>
					<div className="content">
						{/* Search */}
						{this.state.showFilters && (
							<div className="card">
								<div className="card-body">
									<div className="row">
										<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label for="">Province</label>
											<DropDown
												multi={true}
												dropdownRenderer={true}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="ProvinceId"
												options={this.state.Provincelist}
												val={this.state.ProvinceId}
												addPlaceholder=""
												disabled={false}
												loading={this.state.ProvinceLoader}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={true}
												placeholder="Select"
											/>
										</div>

										<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">Sub Recipient</label>
											<DropDown
												multi={true}
												dropdownRenderer={true}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="SrId"
												options={this.state.FilteredSrs}
												val={this.state.SrId}
												addPlaceholder=""
												disabled={false}
												loading={false}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={true}
												placeholder="Select"
											/>
										</div>

										<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">District</label>
											<DropDown
												multi={true}
												dropdownRenderer={true}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="DistrictId"
												options={this.state.FilteredDistrictlist}
												val={this.state.DistrictId}
												addPlaceholder=""
												disabled={false}
												loading={this.state.DistrictLoader}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={true}
												placeholder="Select"
											/>
										</div>

										<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">Tehsil</label>
											<DropDown
												multi={true}
												dropdownRenderer={true}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="TehsilId"
												options={this.state.FilteredTehsillist}
												val={this.state.TehsilId}
												addPlaceholder=""
												disabled={false}
												loading={this.state.TehsilLoader}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={true}
												placeholder="Select"
											/>
										</div>

										<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">
												{this.state.category === ""
													? "BHU/GP"
													: this.state.category === "private"
														? "GP"
														: "BHU"}
											</label>
											<DropDown
												multi={true}
												dropdownRenderer={true}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="BHUId"
												options={this.state.filteredBHUList}
												val={this.state.BHUId}
												addPlaceholder=""
												disabled={false}
												loading={false}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={true}
												placeholder="Select"
											/>
										</div>

										<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">
												{this.state.category === ""
													? "RHC/BMU/PPM-Labs"
													: this.state.category === "public"
														? "RHC/BMU"
														: "PPM-Labs"}
											</label>
											<DropDown
												multi={true}
												dropdownRenderer={true}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="RHCId"
												options={this.state.filteredRHCList}
												val={this.state.RHCId}
												addPlaceholder=""
												disabled={false}
												loading={false}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={true}
												placeholder="Select"
											/>
										</div>

										<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">From</label>
											<DatePicker
												selected={this.state.startDate}
												onChange={(date) => {
													this.HandleDateChange("startDate", date);
												}}
												peekNextMonth
												showMonthDropdown
												showYearDropdown
												dropdownMode="select"
											/>
										</div>

										<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">To</label>
											<DatePicker
												selected={this.state.endDate}
												onChange={(date) => {
													this.HandleDateChange("endDate", date);
												}}
												peekNextMonth
												showMonthDropdown
												showYearDropdown
												dropdownMode="select"
												minDate={this.state.startDate}
											/>
										</div>

										<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">
												{this.state.category === ""
													? "Xpert Site"
													: this.state.category === "public"
														? "Public Xpert Site"
														: "PPM Xpert Site"}
											</label>
											<DropDown
												multi={true}
												dropdownRenderer={true}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="XpertSiteId"
												options={this.state.filteredXpertSiteList}
												val={this.state.XpertSiteId}
												addPlaceholder=""
												disabled={false}
												loading={false}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={true}
												placeholder="Select"
											/>
										</div>

										<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">Category</label>
											<select
												id="category"
												className="form-control"
												onChange={(event) =>
													this.setState({ category: event.target.value })
												}
											>
												<option value="">All</option>
												<option value="public">Public</option>
												<option value="private">Private</option>
											</select>
										</div>

										<div className="formInput_Container Search_InputSelectContainer col-lg-2 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">From Age</label>
											<select
												className="form-control"
												onChange={(event) =>
													this.setState({ startAge: event.target.value })
												}
											>
												{this.state.AgeBracket.map((item) => (
													<option value={item.id}>{item.name}</option>
												))}
											</select>
										</div>

										<div className="formInput_Container Search_InputSelectContainer col-lg-2 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">To Age</label>
											<select
												className="form-control"
												onChange={(event) =>
													this.setState({ endAge: event.target.value })
												}
											>
												{this.state.AgeBracket.map((item) => (
													<option value={item.id}>{item.name}</option>
												))}
											</select>
										</div>

										<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
											<label htmlFor="">Gender</label>
											<select id="gender" className="form-control">
												<option value="">All</option>
												<option value="1">Male</option>
												<option value="2">Female</option>
											</select>
										</div>

										<div
											className="formInput_Container col-md-2 "
											style={{ marginTop: "35px", marginLeft: "14px" }}
										>
											<div className="text-center ">
												<label className="CheckBox_container ">
													<span>Microscope</span>
													<input
														type="checkbox"
														onChange={(e) =>
															this.setState({
																isMicroscope: e.target.checked,
															})
														}
														checked={this.state.isMicroscope}
													/>
													<span className="CheckBox_checkmark"></span>
												</label>
											</div>
										</div>

										<div
											className="formInput_Container col-lg-3 col-md-3 mt8 col-sm-12 col-xs-12 col-12 pl-0"
											style={{ marginTop: "35px" }}
										>
											<button
												onClick={() => {
													this.setState({ isSaveSearch: true }, () => {
														this.GetDashboardStats();
													});
												}}
												id="FormSearchBtn"
												className="btn btn-primary mr-2"
											>
												Search
											</button>
											<button
												onClick={this.ResetPageLastSearch}
												className="btn btn-danger "
												style={{ left: "145px", background: "#EE3651" }}
											>
												Reset
											</button>
										</div>
									</div>
								</div>
							</div>
						)}

						<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
							<ReactToPrint
								bodyclassName="PrintBodyCaseForm"
								documentTitle="Riders For Health-Dashboard"
								trigger={() => (
									<button
										id="Componentprintlink"
										style={{ marginRight: "10px", display: "none" }}
										title="Print Dashboard"
										className="btn"
									>
										<i className="fa fa-print"></i>
									</button>
								)}
								content={() => this.componentRef.current}
							/>
						</div>
						<div ref={this.componentRef}>
							{/* Cards */}
							{this.state.permissions.includes("dashboard-cards") && (
								<div className="row">
									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "#4545ff",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>Total Samples</b>
												<b>
													{this.state.SR_loading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														this.state.SR_totalSamples.toLocaleString()
													)}
												</b>
											</div>
											<div className="card-body py-2">
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>BHUs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.SR_bhUs.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>RHCs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.SR_rhCs.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>GPs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.SR_gPs.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>PPM-Labs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.SR_ppmLabs.toLocaleString()}
													</span>
												</div>
											</div>
										</div>
									</div>

									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "green",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>Total Rides</b>
												<b>
													{this.state.SATR_loading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														this.state.SATR_totalSamples.toLocaleString()
													)}
												</b>
											</div>
											<div className="card-body py-2">
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>Completed Rides</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.SATR_completedRides.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>Total Incentives for Completed Rides</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.SATR_totalIncentivesForCompletedRides.toLocaleString()}
													</span>
												</div>
											</div>
										</div>
									</div>

									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "#e04848",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>Transported Samples</b>
												<b>
													{this.state.TS_loading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														this.state.TS_totalSamples.toLocaleString()
													)}
												</b>
											</div>
											<div className="card-body py-2">
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>BHUs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.TS_bhUs.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>RHCs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.TS_rhCs.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>GPs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.TS_gPs.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>PPM-Labs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.TS_ppmLabs.toLocaleString()}
													</span>
												</div>
											</div>
										</div>
									</div>

									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "purple",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>Transported & Tested Samples</b>
												<b>
													{this.state.TATS_loading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														this.state.TATS_totalSamples.toLocaleString()
													)}
												</b>
											</div>
											<div className="card-body py-2">
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>BHUs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.TATS_bhUs.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>RHCs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.TATS_rhCs.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>GPs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.TATS_gPs.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>PPM-Labs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.TATS_ppmLabs.toLocaleString()}
													</span>
												</div>
											</div>
										</div>
									</div>

									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "brown",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>AFB Positive Cases</b>
												<b>
													{this.state.afbloading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														<>
															{_.round(
																(Number(this.state.afbPositiveSamples) /
																	Number(this.state.afbTestedSamples)) *
																100 || 0,
																2
															)}
															%
														</>
													)}
												</b>
											</div>
											<div className="card-body py-2">
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														AFB Positive Samples
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.afbPositiveSamples.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														AFB Tested Samples
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.afbTestedSamples.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Samples Transported for AFB Test
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.samplesTransportedForAFBTest.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Average Cost/Case Notification
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.afbAverageCost.toLocaleString()}
													</span>
												</div>
											</div>
										</div>
									</div>

									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "orange",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>MTB Detected Cases</b>
												<b>
													{this.state.mtbloading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														<>
															{_.round(
																(Number(this.state.mtbDetectedSamples) /
																	Number(this.state.gxTestedSamples)) *
																100 || 0,
																2
															)}
															%
														</>
													)}
												</b>
											</div>
											<div className="card-body py-2">
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														MTB Detected Samples
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.mtbDetectedSamples.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														GX Tested Samples
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.gxTestedSamples.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Samples Transported for GX Test
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.samplesTransportedForGXTest.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Average Cost/Case Notification
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.mtbAverageCost.toLocaleString()}
													</span>
												</div>
											</div>
										</div>
									</div>

									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "blueviolet",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>RR Detected Cases</b>
												<b>
													{this.state.rr_loading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														<>
															{_.round(
																(Number(this.state.rr_DetectedSamples) /
																	Number(this.state.rr_gxTestedSamples)) *
																100 || 0,
																2
															)}
															%
														</>
													)}
												</b>
											</div>
											<div className="card-body py-2">
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														RR Detected Cases
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.rr_DetectedSamples.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														MTB Detected Samples
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.rr_mtbDetectedSamples.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														GX Tested Samples
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.rr_gxTestedSamples.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Average Cost/Case Notification
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.rr_AverageCost.toLocaleString()}
													</span>
												</div>
											</div>
										</div>
									</div>

									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "teal",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>Turn Arround Time (Hours) </b>
												<b>
													{this.state.turnAroundTimeloading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														""
													)}
												</b>
											</div>
											<div className="card-body py-2">
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Turn arround time (Transportation)
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.turnAroundTimeTransportation.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Turn arround time (AFB Testing)
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.turnAroundTimeAFBTesting.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Turn arround time (GX Testing)
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.turnAroundTimeGXTesting.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}></span>
													<span style={{ fontSize: 12, float: "right" }}></span>
												</div>
											</div>
										</div>
									</div>

									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "black",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>Cost / Transported Sample</b>
												<b>
													{this.state.bhuloading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														""
													)}
												</b>
											</div>
											<div className="card-body py-2">
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>BHUs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.bhus.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>RHCs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.rhcs.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>GPs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.gps.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>PPM-Labs</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.ppmlabs.toLocaleString()}
													</span>
												</div>
											</div>
										</div>
									</div>

									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "darkgoldenrod",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>GX Sites</b>
												<b>
													{this.state.GXSitesloading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														""
													)}
												</b>
											</div>
											<div className="card-body py-2">
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Active / Total Private GX Sites
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{`${this.state.activePrivateGXSites.toLocaleString()} / ${this.state.totalPrivateGXSites.toLocaleString()}`}{" "}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Samples Tested at Private GX
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.samplesTestedPrivateGX.toLocaleString()}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Active / Total Public GX Sites
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{`${this.state.activePublicGXSites.toLocaleString()} / ${this.state.totalPublicGXSites.toLocaleString()}`}{" "}
													</span>
												</div>
												<div style={{ width: "100%", display: "inline-block" }}>
													<span style={{ fontSize: 12 }}>
														Samples Tested at Public GX
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{this.state.samplesTestedPublicGX.toLocaleString()}
													</span>
												</div>
											</div>
										</div>
									</div>

									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "deepskyblue",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>Districs & Riders</b>
												<b>
													{this.state.RD_loading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														""
													)}
												</b>
											</div>
											<div className="card-body py-2">
												<div
													style={{
														width: "100%",
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<span style={{ fontSize: 12 }}>
														Active / Total Districts
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{`${this.state.activeDistricts} / ${this.state.totalDistricts}`}{" "}
														|
														{_.round(
															Number(
																this.state.activeDistricts /
																this.state.totalDistricts
															) || 0,
															2
														)}
													</span>
												</div>
												<div
													style={{
														width: "100%",
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<span style={{ fontSize: 12 }}>
														Active / Riders (CVR)
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{`${this.state.activeRidersPublicServant.toLocaleString()} / ${this.state.totalRidersCVR.toLocaleString()}`}{" "}
														|
														{_.round(
															Number(
																this.state.activeRidersPublicServant /
																this.state.totalRidersCVR
															) || 0,
															2
														)}
													</span>
												</div>
												<div
													style={{
														width: "100%",
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<span style={{ fontSize: 12 }}>
														Active / Riders (Public Servant)
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{`${this.state.activeRidersCVR.toLocaleString()} / ${this.state.totalRidersPublicServant.toLocaleString()}`}{" "}
														|
														{_.round(
															Number(
																this.state.activeRidersCVR /
																this.state.totalRidersPublicServant
															) || 0,
															2
														)}
													</span>
												</div>
												<div
													style={{
														width: "100%",
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<span style={{ fontSize: 12 }}>
														Active / Riders (Project Staff)
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{`${this.state.activeRidersProjectStaff.toLocaleString()} / ${this.state.totalRidersProjectStaff.toLocaleString()}`}{" "}
														|
														{_.round(
															Number(
																this.state.activeRidersProjectStaff /
																this.state.totalRidersProjectStaff
															) || 0,
															2
														)}
													</span>
												</div>
											</div>
										</div>
									</div>

									<div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 pl-0">
										<div
											className="card"
											style={{
												borderRadius: "10px",
												backgroundRepeat: "no-repeat",
												backgroundSize: "cover",
											}}
										>
											<div
												style={{
													borderRadius: "10px 10px 0px 0px",
													color: "white",
													width: "100%",
													display: "flex",
													justifyContent: "space-between",
													backgroundColor: "#c357c3",
													padding: "0.5rem 1.25rem",
												}}
											>
												<b>Health Care Facilities</b>
												<b>
													{this.state.activeLoading ? (
														<i class="fa fa-spinner fa-pulse"></i>
													) : (
														""
													)}
												</b>
											</div>

											<div className="card-body py-2">
												<div
													style={{
														width: "100%",
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<span style={{ fontSize: 12 }}>
														Active / Total BHUs
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{`${this.state.activeBHU.toLocaleString()} / ${this.state.totalBHU.toLocaleString()}`}{" "}
														|
														{_.round(
															Number(
																this.state.activeBHU / this.state.totalBHU
															) || 0,
															2
														)}
													</span>
												</div>
												<div
													style={{
														width: "100%",
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<span style={{ fontSize: 12 }}>
														Active / Total RHCs
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{`${this.state.activeRHC.toLocaleString()} / ${this.state.totalRHC.toLocaleString()}`}{" "}
														|
														{_.round(
															Number(
																this.state.activeRHC / this.state.totalRHC
															) || 0,
															2
														)}
													</span>
												</div>
												<div
													style={{
														width: "100%",
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<span style={{ fontSize: 12 }}>
														Active / Total GPs
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{`${this.state.activeGP.toLocaleString()} / ${this.state.totalGP.toLocaleString()}`} |
														{_.round(
															Number(
																this.state.activeGP / this.state.totalGP
															) || 0,
															2
														)}
													</span>
												</div>
												<div
													style={{
														width: "100%",
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<span style={{ fontSize: 12 }}>
														Active / Total PPM-Labs
													</span>
													<span style={{ fontSize: 12, float: "right" }}>
														{`${this.state.activePPMLabs.toLocaleString()} / ${this.state.totalPPMlabs.toLocaleString()}`}{" "}
														|
														{_.round(
															Number(
																this.state.activePPMLabs /
																this.state.totalPPMlabs
															) || 0,
															2
														)}
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							)}

							{/* Line Chart */}
							{this.state.permissions.includes("weekly-samples-line-chart") && (
								<div className="row">
									<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 pl-0">
										<div className="card">
											<div className="card-body">
												<span>Current Week's plotting on the samples</span>
												<LineChart data={this.state.LineChartData} />
											</div>
										</div>
									</div>
								</div>
							)}

							{/* Pie Chart */}
							{this.state.permissions.includes("weekly-samples-pie-chart") && (
								<div className="row">
									<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 pl-0">
										<div className="card">
											<div className="card-body">
												<div className="row">
													<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pl-0">
														<select
															className="form-control"
															id="PieChartTypeVal"
															onChange={this.handlePieChartViewTypeChange}
														>
															<option value="received">Samples received</option>
															<option value="delivered">
																{" "}
																Samples delivered
															</option>
															<option value="mtb">MTB cases</option>
														</select>
													</div>
													<PieCharts
														heading=""
														data={this.state.PieChartData}
														IsNoData={true}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							)}

							{/* Bars Graph */}
							{this.state.permissions.includes("weekly-rides-count-chart") && (
								<div className="row">
									<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 pl-0">
										<div className="card">
											<div className="card-body">
												<BarsGraph
													data={this.state.BarsChartData}
													caption="Current Week's Rides Count"
													xAxisName="Date"
												/>
											</div>
										</div>
									</div>
								</div>
							)}

							<div className="row">
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 pl-0">
									<div className="card">
										<div className="card-body">
											<BarsGraph
												data={this.state.subRecepientBarsChartData}
												caption="Sub Recipients Stats"
												xAxisName="Samples"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true,
})(Dashboard);
